import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface FeatureToggleReducer {
    salgspantTrafficLight: boolean;
    salgspantActivateLoanFromLc: boolean;
    salgspantSigningRedirect: boolean;
    salgspantSkipKyc: boolean;
    salgspantSkipSbl: boolean;
    salgspantShowIncomeInput: boolean;
    salgspantSkipConsent: boolean;
    salgspantUnavailable: boolean;
}
export const initialState: FeatureToggleReducer = {
    salgspantTrafficLight: false,
    salgspantActivateLoanFromLc: false,
    salgspantSigningRedirect: false,
    salgspantSkipKyc: false,
    salgspantSkipSbl: false,
    salgspantShowIncomeInput: false,
    salgspantSkipConsent: false,
    salgspantUnavailable: false,
};

export const featureReducer = (state = initialState, action: AppActions = {} as AppActions) => {
    switch (action.type) {
        case actionTypes.FEATURE_TOGGLE_FULFILLED:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
